const EmployeeManagementIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_3153_50782)"
        fill-opacity="0.1"
      />
      <path
        d="M12.6588 24C10.7155 24 8.80198 24 6.8586 24C5.93176 24 5.60288 23.5814 5.75237 22.7144C6.32043 19.4854 9.10096 17.0636 12.33 16.944C15.7384 16.8244 18.7581 19.0668 19.5354 22.2659C19.8643 23.5814 19.5354 24 18.19 24C16.3363 24 14.5125 24 12.6588 24Z"
        fill="#052351"
      />
      <path
        d="M12.689 8.00452C14.7819 8.00452 16.4562 9.64892 16.4562 11.7119C16.4562 13.7151 14.6922 15.4492 12.6591 15.4492C10.6261 15.4492 8.92188 13.7151 8.92188 11.682C8.92188 9.61902 10.5663 8.00452 12.689 8.00452Z"
        fill="#052351"
      />
      <path
        opacity="0.6"
        d="M19.2362 8.00448C20.8507 8.00448 22.1663 8.93133 22.7642 10.3963C23.3622 11.9211 22.9735 13.5655 21.7776 14.612C20.7013 15.5687 18.9672 15.8079 17.7114 15.18C17.263 14.9409 16.964 14.8213 17.4723 14.2532C18.728 12.848 18.728 10.8747 17.5022 9.4396C16.9939 8.84163 17.1733 8.63235 17.7413 8.36326C18.2496 8.09418 18.7878 7.97459 19.2362 8.00448Z"
        fill="#052351"
      />
      <path
        opacity="0.6"
        d="M21.2991 23.8505C21.7775 23.2227 21.5981 22.6546 21.4486 22.0566C20.9104 20.1731 19.7743 18.7379 18.0701 17.7513C17.8309 17.6018 17.502 17.5719 17.3525 17.2729C21.2094 15.9574 25.724 18.7678 26.2622 22.7443C26.3519 23.4021 26.1426 23.8206 25.425 23.8206C24.0497 23.8505 22.7342 23.8505 21.2991 23.8505Z"
        fill="#052351"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3153_50782"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default EmployeeManagementIconMenu
